export enum RolesBoEnum {
  RT = 'rt,click',
  PCL = 'pcl,click',
  ADMIN = 'admin,click',
  CEAC = 'ceac,click',
  ORT = 'ort,click',
  VRT = 'vrt,click',
  APP = 'app,click',
  APPRT = 'apprt,click',
  OPTER = 'opterr,click'
}
